import { infiniteQueryOptions } from '@tanstack/react-query';

import { fetchExcludeList } from './api';
import { excludeListQueryKeys } from './query-keys';

const EXCLUDE_LIST_LIMIT = 20;

export function excludeListInfiniteQueryOptions(workspaceId: string) {
  return infiniteQueryOptions({
    queryKey: excludeListQueryKeys.all(workspaceId),
    queryFn: ({ signal, pageParam }) =>
      fetchExcludeList(
        {
          workspaceId,
          cursor: pageParam,
          limit: EXCLUDE_LIST_LIMIT,
        },
        signal,
      ),
    initialPageParam: null as string | null,
    getNextPageParam: (lastPage) => lastPage.next_cursor,
  });
}
